import React, { FunctionComponent, ReactElement } from 'react'
import dayjs from 'dayjs'
import Grid from '@sport1/react-elements/Grid'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Touchable from '@sport1/react-elements/Touchable'
import SmallBodyFont from '../../Theme/Fonts/SmallBody'
import CardHeadlineFont from '../../Theme/Fonts/CardHeadline'
import { MonthNavigatorProps } from '../Types'
const todaysDate = dayjs()
const MonthNavigator: FunctionComponent<MonthNavigatorProps> = ({
    navigatorDate,
    isMaxSizeApp,
    selectableDaysRange,
    onPressLeft,
    onPressRight,
}): ReactElement => {
    const selectedDate = navigatorDate.locale('de').format('MMMM YYYY').toUpperCase()

    const dayNumber = todaysDate.date()
    const leftArrowIsVisible = navigatorDate
        .date(dayNumber - 1)
        .isAfter(todaysDate.subtract(selectableDaysRange || 60, 'day'))
    const rightArrowIsVisble = navigatorDate
        .date(dayNumber + 1)
        .isBefore(todaysDate.add(selectableDaysRange || 60, 'day'))
    return (
        <Grid noExpand horizontal center paddingBottom={5}>
            <Grid width={30} noExpand>
                {leftArrowIsVisible ? (
                    <Touchable onPress={onPressLeft}>
                        <Grid width={30}>
                            <FontelloIcon name="scroll-left" fontSize={15} color="onyx" />
                        </Grid>
                    </Touchable>
                ) : null}
            </Grid>

            <Grid center>
                {isMaxSizeApp ? (
                    <CardHeadlineFont color="onyx">{selectedDate}</CardHeadlineFont>
                ) : (
                    <SmallBodyFont bold color="onyx">
                        {selectedDate}
                    </SmallBodyFont>
                )}
            </Grid>

            <Grid noExpand width={30}>
                {rightArrowIsVisble ? (
                    <Touchable onPress={onPressRight}>
                        <Grid noExpand alignRight width={30}>
                            <FontelloIcon name="scroll-right" fontSize={15} color="onyx" />
                        </Grid>
                    </Touchable>
                ) : null}
            </Grid>
        </Grid>
    )
}

export default MonthNavigator
